import React from 'react'

const Pricing = () => {
  const prices = [
    {
      title: 'free',
      features: [
        'Unlimited tracks',
        'HQ audio',
        'Unlimited playlists',
        'Ads',
        '1 account',
      ],
      rate: 0.0,
    },
    {
      title: 'personal',
      features: [
        'Unlimited tracks',
        'HQ audio',
        'Unlimited playlists',
        'No ads',
        '1 account',
      ],
      rate: 1.99,
    },
    {
      title: 'family',
      features: [
        'Unlimited tracks',
        'HQ audio',
        'Unlimited playlists',
        'No ads',
        'upto 6 accounts',
      ],
      rate: 3.49,
    },
  ]
  return (
    <div className="uk-width-5-6@s uk-width-1-1 uk-margin-auto  uk-margin-top">
      <h3
        className="uk-margin-small-top"
        style={{
          width: `96%`,
          margin: `32px auto`,
        }}
      >
        Pricing
      </h3>
      <div
        className="uk-grid-match uk-child-width-expand@s uk-text-center  uk-margin-small-top"
        data-uk-grid
      >
        {prices &&
          prices.map((price, i) => {
            const { title, features, rate } = price
            return (
              <div className="pri" key={i}>
                <div
                  className="uk-card uk-card-default uk-border-rounded"
                  style={{
                    color: `#000`,
                    // boxShadow: `0 2px 8px grey !important`,
                    boxShadow: `0 5px 15px rgba(0,0,0,0.2) !important`,
                  }}
                >
                  <h3 className="uk-card-title uk-padding-remove-bottom uk-padding-small uk-text-capitalize">
                    {title}
                  </h3>
                  <ul className="uk-list">
                    {features &&
                      features.map((feature, n) => (
                        <li style={{ color: '#000' }} key={n}>
                          {feature}
                        </li>
                      ))}
                  </ul>
                  <h3 className="uk-card-title">{rate + `/ month`}</h3>
                </div>
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default Pricing
